const profileNativeFetch = window.fetch.bind(window);
let cachedStudentCode = "";
let liveQcmTimer: number | null = null;

type LiveQcmResponse = {
  active: boolean;
  session?: { code: string; chapter: string; theme?: string; status: string; href: string } | null;
};

async function hydrateStudentCode() {
  try {
    const response = await profileNativeFetch("/api/account/profile", { credentials: "include" });
    if (!response.ok) return;
    cachedStudentCode = String((await response.json()).studentCode ?? "").trim();
  } catch { /* le compte reste utilisable même si le profil ne charge pas */ }
}

function closeProfileDialog() {
  document.querySelector(".student-profile-overlay")?.remove();
}

async function openProfileDialog() {
  closeProfileDialog();
  if (!cachedStudentCode) await hydrateStudentCode();

  const overlay = document.createElement("div");
  overlay.className = "student-profile-overlay";
  overlay.innerHTML = `
    <form class="student-profile-dialog">
      <div class="student-profile-title">
        <div><small>Mon compte</small><h2>Modifier mon pseudo</h2></div>
        <button type="button" class="student-profile-close" aria-label="Fermer">×</button>
      </div>
      <label><span>Pseudo de connexion</span><input name="studentCode" maxlength="40" autocomplete="username" required /></label>
      <p class="student-profile-help">Ce pseudo sert uniquement à te connecter à CompetenceO. Ton nom et ton prénom sur ta fiche élève ne changent pas.</p>
      <p class="student-profile-error" hidden></p>
      <button class="student-profile-save" type="submit">Enregistrer</button>
    </form>`;
  document.body.appendChild(overlay);

  const form = overlay.querySelector<HTMLFormElement>("form")!;
  const input = form.elements.namedItem("studentCode") as HTMLInputElement;
  input.value = cachedStudentCode;
  input.focus();
  input.select();

  overlay.addEventListener("mousedown", (event) => { if (event.target === overlay) closeProfileDialog(); });
  overlay.querySelector(".student-profile-close")?.addEventListener("click", closeProfileDialog);

  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    const save = form.querySelector<HTMLButtonElement>(".student-profile-save")!;
    const error = form.querySelector<HTMLElement>(".student-profile-error")!;
    error.hidden = true;
    save.disabled = true;
    save.textContent = "Enregistrement…";

    try {
      const response = await profileNativeFetch("/api/account/profile", {
        method: "PATCH",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ studentCode: input.value }),
      });
      const body = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(body.error ?? "Modification impossible");
      cachedStudentCode = String(body.studentCode ?? input.value).trim();
      closeProfileDialog();
    } catch (reason) {
      error.textContent = reason instanceof Error ? reason.message : "Modification impossible";
      error.hidden = false;
      save.disabled = false;
      save.textContent = "Enregistrer";
    }
  });
}

async function refreshLiveQcmButton() {
  const button = document.querySelector<HTMLButtonElement>("[data-student-live-qcm]");
  if (!button) return;
  try {
    const response = await profileNativeFetch("/api/student/live-qcm", { credentials: "include", cache: "no-store" });
    if (!response.ok) throw new Error();
    const body = await response.json() as LiveQcmResponse;
    const session = body.active ? body.session : null;
    button.disabled = !session;
    button.dataset.href = session?.href ?? "";
    button.textContent = session ? "QCM Live · Rejoindre" : "QCM Live · Aucun QCM";
    button.title = session ? `${session.theme ? `${session.theme} · ` : ""}${session.chapter}` : "Aucun QCM Live pour ta classe";
  } catch {
    button.disabled = true;
    button.dataset.href = "";
    button.textContent = "QCM Live · Indisponible";
  }
}

function ensureLiveQcmPolling() {
  if (liveQcmTimer !== null) return;
  void refreshLiveQcmButton();
  liveQcmTimer = window.setInterval(() => {
    if (!document.querySelector(".student-space")) {
      if (liveQcmTimer !== null) window.clearInterval(liveQcmTimer);
      liveQcmTimer = null;
      return;
    }
    void refreshLiveQcmButton();
  }, 3000);
}

function ensureProfileButton() {
  const actions = document.querySelector<HTMLElement>(".student-space .student-account-actions");
  if (!actions) return;

  if (!actions.querySelector("[data-student-live-qcm]")) {
    const liveButton = document.createElement("button");
    liveButton.type = "button";
    liveButton.dataset.studentLiveQcm = "true";
    liveButton.disabled = true;
    liveButton.textContent = "QCM Live · Vérification…";
    liveButton.addEventListener("click", () => {
      const href = liveButton.dataset.href;
      if (href) window.location.href = href;
    });
    actions.prepend(liveButton);
  }

  if (!actions.querySelector("[data-student-profile-button]")) {
    const button = document.createElement("button");
    button.type = "button";
    button.dataset.studentProfileButton = "true";
    button.textContent = "Modifier mon pseudo";
    button.addEventListener("click", () => void openProfileDialog());
    actions.prepend(button);
  }

  ensureLiveQcmPolling();
}

const profileObserver = new MutationObserver(ensureProfileButton);
profileObserver.observe(document.documentElement, { childList: true, subtree: true });
window.setTimeout(ensureProfileButton, 0);
